<template>
  <div class="sidebar" :style="{width:width}">
    <ul class="main-menu">
      <div class="head">
        <div class="img">
          <img :src="adminMessage.headimg || $store.state.default_img_url">
        </div>
      </div>
      <li
        :class="{active:routeMatch[0].path===item.path}"
        v-for="(item,index) in permission(mainRoutes)"
        @click="currentRouteChange(item)"
        :key="index">
        <i class="iconfont" v-html="item.icon"></i>
        <span>{{item.title}}</span>
        <span class="badge" v-if="item.meta.badge">{{limitBadge(item.meta.badge)}}</span>
      </li>
    </ul>
    <ul class="sub-menu">
      <li
        :class="{active:routeMatch[1].path===item.path}"
        v-for="(item,index) in permission(currentRoute.children)"
        @click="subMenuChange(item.path)"
        :key="index">
        <span class="title">{{item.title}}</span>
        <span class="badge" v-if="item.meta && item.meta.badge">{{limitBadge(item.meta.badge)}}</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'Sidebar',
  props: ['width'],
  data () {
    return {
      currentRoute: {},
      subMenu: {},
      mainRoutes: this.$store.getters.userRoutes,
      version: this.$store.state.version,
      // version: 'multi',
      timer: null
    }
  },
  computed: {
    adminMessage () {
      return this.$store.state.adminMessage
    },
    routeMatch () {
      return this.$route.matched
    }
  },
  watch: {
    $route (newValue, oldValue) {
      let routes = this.mainRoutes
      let matched = this.routeMatch
      for (let i = 0; i < routes.length; i++) {
        if (matched[0].path === routes[i].path) {
          this.currentRouteChange(matched[0])
        }
      }
    }
  },
  mounted () {
    let routes = this.mainRoutes
    let matched = this.routeMatch
    for (let i = 0; i < routes.length; i++) {
      if (matched[0].path === routes[i].path) {
        this.currentRoute = this.mainRoutes[i]
        if (matched[1]) {
          this.$router.push(matched[1])
        } else {
          this.$router.push(this.currentRoute.children[0].path)
        }
      }
    }
    this.$store.dispatch('getUnread').then()
    this.timer = setInterval(_ => {
      this.$store.dispatch('getUnread').then()
    }, 10 * 1000)
  },
  methods: {
    permission (route) {
      route = route || []
      let powerList = []
      route.forEach(item => {
        if (item.meta) {
          if (item.meta.roles && item.meta.roles.indexOf(this.version) > -1) {
            powerList.push(item)
          }
          if (!item.meta.roles) {
            powerList.push(item)
          }
        } else {
          powerList.push(item)
        }
      })
      return powerList
    },
    currentRouteChange (item) {
      const currentRoute = item
      if (this.currentRoute.path === currentRoute.path) {
        return false
      } else {
        this.currentRoute = currentRoute
        this.$router.push(this.permission(currentRoute.children)[0].path)
      }
    },
    subMenuChange (path) {
      this.$router.push(path)
    },
    limitBadge (num) {
      if (num > 99) {
        return '99+'
      } else {
        return num
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>
<style lang="less" scoped>
.sidebar {
  height: 100%;
  background-color: #ffffff;
  box-sizing: border-box;
  border-right: 1px solid #E4E7ED;
  display: flex;
  ul {
    height: 100%;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    &.main-menu {
      width: 100px;
      background-color: #222D32;
      color: #b8c7ce;
      li {
        height: 44px;
        display: flex;
        align-items: center;
        border-left: 3px solid #222D32;
        font-size: 14px;
        cursor: pointer;
        &:hover,
        &.active {
          border-left: 3px solid #3c8dbc;
          background-color: #1E282C;
        }
        i {
          padding-left: 8px;
          padding-right: 8px;
        }
      }
      .head {
        height: 70px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 40px solid #12181B;
        .img {
          width: 50px;
          height: 50px;
          border-radius: 7px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    &.sub-menu {
      width: 120px;
      color: #444444;
      li {
        height: 40px;
        line-height: 40px;
        border-bottom:1px solid #E4E7ED;
        text-align: center;
        font-size: 13px;
        cursor: pointer;
        position: relative;
        &:hover, &.active{
          background-color: #eee;
        }
        &.active::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 3px;
          background-color: red;
        }
      }
    }
  }
}
.badge {
  display: inline-block;
  color: #fff;
  font-size: 11px;
  padding: 0 6px;
  height: 18px;
  line-height: 18px;
  border-radius: 10px;
  background-color: #F56C6C;
  margin-left: 3px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar.vue